import {
  GET_OPPORTUNITY_CHART_DATA,
  GET_OPPORTUNITY_CHART_OPPORTUNITIES,
  GET_OPPORTUNITY_CHART_PROSPECTS,
  GET_OPPORTUNITY_CHART_PROSPECT_STAGE,
  OPPORTUNITY_CHART_LOADING,
} from './dashboardOpportunityChartTypes'

const initState = {
  data: [],
  isLoading: false,
  prospectStage: [],
  opportunities: {
    data: [],
    query: {
      first: 0,
      limit: 5,
      totalRecords: 0,
    },
  },
  prospects: {
    data: [],
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
}

const PipelineReducer = (state = initState, action) => {
  switch (action.type) {
    case OPPORTUNITY_CHART_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case GET_OPPORTUNITY_CHART_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case GET_OPPORTUNITY_CHART_PROSPECT_STAGE:
      return {
        ...state,
        prospectStage: action.payload,
      }

    case GET_OPPORTUNITY_CHART_OPPORTUNITIES:
      return {
        ...state,
        opportunities: action.payload,
      }
    case GET_OPPORTUNITY_CHART_PROSPECTS:
      return {
        ...state,
        prospects: action.payload,
      }
    default:
      return state
  }
}

export default PipelineReducer
